// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"72725aef","198":"0e6a1d53"}[chunkId] + ".chunk.js";
};